"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceContractTerms20230418 = void 0;
var abstract_package_1 = require("./abstract-package");
var package_enum_1 = require("./package-enum");
var ServiceContractTerms20230418;
(function (ServiceContractTerms20230418) {
  /** Пакет условий услуги с фиксированной или повторяющейся серией занятий */
  var Package = /** @class */function (_super) {
    __extends(Package, _super);
    function Package() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.package = package_enum_1.PackageEnum.ServiceContractTerms20230418Package;
      return _this;
    }
    Package.prototype.getClassProperties = function () {
      return __spreadArray(__spreadArray([], _super.prototype.getClassProperties.call(this), true), ['user_service_id', 'type', 'title', 'excerpt', 'cover_id', 'cover', 'description', 'subject_id', 'keywords', 'price_tier', 'language_id', 'duration', 'discount', 'discount_rule', 'category_id', 'participants_limit', 'level_id', 'options', 'media_url', 'schedule'], false);
    };
    Package.prototype.applyValues = function (values) {
      _super.prototype.applyValues.call(this, values);
      var _values = values;
      this.options = new Options(_values.options);
      this.schedule = new Schedule(_values.schedule);
    };
    return Package;
  }(abstract_package_1.AbstractPackage);
  ServiceContractTerms20230418.Package = Package;
  var Options = /** @class */function () {
    function Options(values) {
      this.requirements = values.requirements || [];
      this.skills = values.skills || [];
      this.weekdays = values.weekdays || [];
      this.meetings_limit = Number(values.meetings_limit);
      this.age_from = Number(values.age_from);
      this.age_to = Number(values.age_to);
    }
    return Options;
  }();
  ServiceContractTerms20230418.Options = Options;
  var Schedule = /** @class */function () {
    function Schedule(values) {
      this.interval = values.interval;
      this.begin_at = new Date(values.begin_at);
      this.end_at = values.end_at ? new Date(values.end_at) : null;
      this.total = values.total || null;
      this.events = (values.events || []).map(function (e) {
        return new Event(e);
      });
    }
    return Schedule;
  }();
  ServiceContractTerms20230418.Schedule = Schedule;
  var Event = /** @class */function () {
    function Event(values) {
      this.id = values.id;
      this.begin_at = new Date(values.begin_at);
      this.end_at = new Date(values.end_at);
    }
    return Event;
  }();
  ServiceContractTerms20230418.Event = Event;
})(ServiceContractTerms20230418 = exports.ServiceContractTerms20230418 || (exports.ServiceContractTerms20230418 = {}));
